import React from "react";

import { Form, Select, Button, Col, Row } from "antd";
import { bankAccounts } from "../../../../../utils/NewPropertyHelper";
import { v4 as uuidv4 } from "uuid";

function BankAccounts({accounts, setAccounts}) {

  const addAccount = () => {
    const newAccounts = { id: uuidv4(), cashGLAccount: "", bankAccount: ""};
    setAccounts([...accounts, newAccounts]);
  };

  const removeAccount = (id) => {
    const updatedAccounts = accounts.filter((item) => item.id !== id);
    setAccounts(updatedAccounts);
  };

  const handleChange = (value, name, id) => {
    const newAccounts = accounts.map((item) => {
      if (item.id === id) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setAccounts(newAccounts);
  };
  // const initialList = [
  //   {
  //     id: uuidv4(),
  //     cashGlAccount: "23291: Rental Income Account",
  //     accountType: "Operating Cash Account",
  //   },
  //   {
  //     id: uuidv4(),
  //     cashGlAccount: "23292: Security Deposit Bank Account",
  //     accountType: "Escrow Account",
  //   },
  // ];

  // const [accounts, setAccounts] = useState(initialList);

  // function handleAddAccount() {
  //   const newList = accounts.concat({ id: uuidv4() });
  //   setAccounts(newList);
  // }

  // function handleRemoveAccount(id) {
  //   const newList = accounts.filter((item) => item.id !== id);
  //   setAccounts(newList);
  // }

  return (
    <>
      <Row style={{ marginBottom: 8 }}>
        <Col className="tableHead" span={13}>
          <Form.Item required label="Cash GL Account"></Form.Item>
        </Col>
        <Col className="tableHead" span={10}>
          <Form.Item required label="Bank Account"></Form.Item>
        </Col>
        <Col span={1}></Col>
      </Row>

      <ul>
        {accounts.map((item, index) => (
          <li key={item.id}>
            <Row gutter={[8, 0]}>
              <Col span={13}>
                {index > 1 ? (
                  <Form.Item
                    name={`cashGlAccount${index}`}
                    rules={[{ required: true }]}
                  >
                    <Select style={{ width: "100%" }} options={bankAccounts}  value={item.cashGLAccount} onChange={(value)=>handleChange(value, 'cashGLAccount', item.id)}/>
                  </Form.Item>
                ) : (
                  <Form.Item name={`cashGlAccount${index}`}>
                    <p style={{ marginTop: "22px" }}>{item.cashGLAccount}</p>
                  </Form.Item>
                )}
              </Col>
              <Col span={10}>
                {/* {
                    accounts.length < 2 && <span
                    style={{
                      fontSize: "11px",
                      color: "GrayText",
                      marginLeft: "2px",
                    }}
                  >
                    {item.accountType}
                  </span> 
                } */}
                <Form.Item
                  name={`bankAccount${index}`}
                  rules={[{ required: true }]}
                >
                  <Select options={bankAccounts} style={{ width: "100%" }} value={item.bankAccount} onChange={(value)=>handleChange(value, 'bankAccount', item.id)}/>
                </Form.Item>
              </Col>
              <Col span={1} style={{ display: index > 1 ? "block" : "none" }}>
                {accounts.length > 2 ? (
                  <Button
                    className="roundSmallButton"
                    onClick={() => {
                      removeAccount(item.id);
                    }}
                    type="primary"
                    shape="circle"
                    icon={<i className="fa-sharp fa-solid fa-xmark"></i>}
                    size={"small"}
                  />
                ) : (
                  <></>
                )}
              </Col>
            </Row>
          </li>
        ))}

        <Button
          className="addPropertyGroupButton"
          type="primary"
          onClick={()=>addAccount()}
          style={{width: "100%"}}
          icon={<i className="fa-solid fa-circle-plus"></i>}
        >
          Add Another Bank Account
        </Button>
      </ul>
    </>
  );
}

export default BankAccounts;
